import React from 'react';
import IconButton from '@material-ui/core/IconButton';
//import HistoryIcon from '@material-ui/icons/History';
// import Popover from '@material-ui/core/Popover';
// import Box from '@material-ui/core/Box';
// import Button from '@material-ui/core/Button';
// import IntlMessages from '../../utility/IntlMessages';
// import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
//import {Fonts} from '../../../shared/constants/AppEnums';
//import {CremaTheme} from '../../../types/AppContextPropsType';

import {useHistory} from 'react-router-dom';
import useStyles from '../AppLayout/Standard/AppHeader.style';  
import { Box } from '@material-ui/core';
import { Fonts } from '../../../shared/constants/AppEnums';

interface HistoryMessagesProps {}

const HistoryMessages: React.FC<HistoryMessagesProps> = () => {
  // const [
  //   anchorMessages,
  //   setAnchorMessages
  // ] = React.useState<HTMLButtonElement | null>(null);

  const onClickHistoryButton = (
    //event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    //setAnchorMessages(event.currentTarget);
    history.push('/order');
  };

  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <IconButton
        className={clsx(classes.notiBtn, 'notiBtn')}
        color='inherit'
        onClick={onClickHistoryButton}>
          {/* <HistoryIcon className={clsx(classes.materialUiIcon, 'HistoryIcon')} /> */}
          <Box
            ml={4}
            mr={1}
            fontSize={{xs:11, sm:12, md:16}}
            fontFamily='Montserrat'
            fontWeight={Fonts.REGULAR}
            component='span'>
              History
          </Box>
        {/* <Hidden smUp>
          <Box
            ml={4}
            fontSize={16}
            fontFamily='Montserrat'
            fontWeight={Fonts.REGULAR}
            component='span'>
            <IntlMessages id='sidebar.ecommerce.history' />
          </Box>
        </Hidden> */}
      </IconButton>

      {/* <Popover
        anchorEl={anchorMessages}
        id='app-message'
        className={classes.crPopover} //this is the style of cart container size
        open={Boolean(anchorMessages)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorMessages(null)}>
        <Box>

          <Box px={5} py={3}>
            <Box component='h5' fontWeight={Fonts.MEDIUM}>
              <IntlMessages id='sidebar.ecommerce.history' />
            </Box>
          </Box>
          <Box
            mb={2}
            display='flex'
            flexDirection={{xs: 'row', sm: 'row'}}
            alignItems={{xs:'center',sm: 'center'}}
            justifyContent={{xs:'center',sm: 'center'}}
            >
            <Button
              variant='contained'
              color='primary'
              size='small'
              onClick={() => {
                setAnchorMessages(null);
                history.push('/order');
              }}
              className={classes.btnRoot}>
              <IntlMessages id='common.viewHistory' />
            </Button>
          </Box>
        </Box>
      </Popover> */}
    </>
  );
};

export default HistoryMessages;
